import React, { useContext, useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import EvaluationTemplateView from '../components/content/evaluation/EvaluationTemplateView';
import EvaluationSessionView from '../components/content/evaluation/EvaluationSessionView';
import EvaluationSessionEvaluateView from '../components/content/evaluation/EvaluationSessionEvaluateView';
import EvaluationTableViews from '../experimental/components/content/evaluations/EvaluationTableViews';
import { useRegAssociationAdminPermissions } from '../helpers/adminHelper';
import { Context as RegistrationAdminContext } from '../providers/RegistrationAdminProvider';

const EvaluationsView = () => {
  const { state, fetchRegScoutReportEvaluationOptions } = useContext(
    RegistrationAdminContext
  );
  const { regAssociation } = useRegAssociationAdminPermissions();

  useEffect(() => {
    if (
      regAssociation &&
      state.regScoutReportEvaluationOptions.value?.pkRegAssociation !==
        regAssociation?.pkRegAssociation
    ) {
      fetchRegScoutReportEvaluationOptions(regAssociation.pkRegAssociation);
    }
  }, [regAssociation]);

  return (
    <Routes>
      <Route
        element={<EvaluationTemplateView />}
        path="/templates/:pkRegScoutReport"
      />
      <Route
        element={<EvaluationSessionView />}
        path="/sessions/:pkRegScoutReportEvaluationSession"
      />
      <Route
        element={<EvaluationSessionEvaluateView />}
        path="/sessions/:pkRegScoutReportEvaluationSession/evaluate"
      />
      <Route
        element={<EvaluationSessionEvaluateView />}
        path="/sessions/:pkRegScoutReportEvaluationSession/evaluate/:pkRegScoutReportEvaluationSessionEntry"
      />
      <Route element={<EvaluationTableViews />} path="*" />
    </Routes>
  );
};

export default EvaluationsView;
